import { NgClass } from '@angular/common';
import { Component } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Actions } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { AppDialogUiReduxObject, ConfirmationDialogButton, ConfirmationDialogComponent } from '@safarilaw-webapp/shared/dialog/store-access';
import { SafariFormComponent } from '@safarilaw-webapp/shared/ui-kit/safari-form';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';

@Component({
  selector: 'sl-lpms-change-reviewer-confirmation-dialog',
  templateUrl: './change-reviewer-dialog.component.html',
  styleUrls: ['./change-reviewer-dialog.component.scss'],
  imports: [SafariFormComponent.standaloneImports, NgClass]
})
export class ChangeReviewerDialogComponent extends ConfirmationDialogComponent {
  static ClassId = 'CHANGEREVIEWER_DIALOG_COMPONENT-cc5d-4e3d-91fb-3a378a9b6e2a';
  ConfirmationDialogButton = ConfirmationDialogButton;

  form: FormGroup;
  constructor(
    dialogReduxObject: AppDialogUiReduxObject,
    bsModalService: BsModalService,
    store: Store<any>,
    actions: Actions,
    bsModalRef: BsModalRef,
    private _formBuilder: FormBuilder
  ) {
    super(dialogReduxObject, bsModalService, store, actions, bsModalRef);
    this.form = this._formBuilder.group({
      reviewerId: [null]
    });
  }

  closeModal(dialogButton: ConfirmationDialogButton = ConfirmationDialogButton.Auto) {
    if (dialogButton == ConfirmationDialogButton.Ok) {
      this.dialogData = {
        reviewerId: this.form.get('reviewerId').value
      };
    }
    super.closeModal(dialogButton);
  }
}
